import { APP_INITIALIZER, ApplicationConfig, LOCALE_ID, PLATFORM_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { provideHttpClient, HTTP_INTERCEPTORS, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { KeycloakInterceptor } from '../services/http-interceptor/http-interceptor.service';
import { KeycloakAuthService } from '../services/auth/auth.service';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { registerLocaleData, isPlatformBrowser } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';

registerLocaleData(localeEs, 'es-ES');

export function initializeKeycloak(keycloakAuthService: KeycloakAuthService, platformId: object) {
  return () => {
    if (isPlatformBrowser(platformId)) {
      return keycloakAuthService.init();
    }
    return Promise.resolve();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'es-ES' },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    provideAnimationsAsync(),
    provideClientHydration(withEventReplay()),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideIonicAngular(),
    providePrimeNG({
        theme: {
            preset: Aura,
            options:{
              darkModeSelector: 'none'
            }
        }
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakAuthService, PLATFORM_ID] 
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: KeycloakInterceptor,
      multi: true
    }
  ],
};